import axios from "axios";

const studentAxios = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  
});

/* ================================
   REQUEST INTERCEPTOR
================================ */
studentAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const sessionId = localStorage.getItem("currentSessionId");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (sessionId) {
      config.headers["x-session-id"] = sessionId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================================
   RESPONSE INTERCEPTOR (OPTIONAL)
================================ */
studentAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Auto logout if token/session is invalid
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.clear();
      window.location.href = "/student/login";
    }
    return Promise.reject(error);
  }
);

export default studentAxios;
